import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import TellUsYourDreamOrProject from "./sections/TellUsYourDreamOrProject";
import PracticalDetails from "./sections/PracticalDetails";
import RequestClearance from "./sections/RequestClearance";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <TellUsYourDreamOrProject />
      <PracticalDetails />
      <RequestClearance />
      <Footer />
    </div>;
}